
import React, { Component } from "react";

import Card from '@material-ui/core/Card';

// import Button from '@material-ui/core/Button'

import '../App.css'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
// import Typography from '@material-ui/core/Typography';

import { MenuItem } from '@material-ui/core'
import { getEventsData } from '../services/userServices';
import { PropTypes } from "prop-types";
import { withStyles, } from "@material-ui/core";
import TopBar from "../components/TopBar";



const styles = theme => ({
  root: {
      display: "flex",

  },

  content: {
      flexGrow: 1,
      padding: theme.spacing.unit * 3,
      transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
      })
  }
});

class EventsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchEvent: [],

      trash:this.props.trash

    }

    this.handleTrash = this.handleTrash.bind(this)

  }

  componentDidMount() {

    getEventsData().then((response) => {
      // console.log("response", response);
      this.setState({
        fetchEvent: response
      });
      // console.log("fetchEvent", this.state.fetchEvent);
    })
      .catch((error) => {
        console.log(error);
      });
  }



  editClick = event => {  
    // console.log(history);
    try {
      
      event.preventDefault();
      this.props.history.push("/editPage", event.target.parentElement.id);
    } catch (err) {
      console.log("error at editing in display events");
    }
  };



  // trash = e => {
  //   try {
  //     e.preventDefault();
  //     this.props.history.push("/trash");
  //   } catch (err) {
  //     console.log("error at deleting in display events");
  //   }
  // };


  async handleTrash(value) {
    // console.log("+++++++++++++++++++++++++++++++++++++",trash);
    //  console.log("trash", value);
     await this.setState({
         trash: !value
     })
     // isTrashed(this.props.navigation.state.params.Display, this.props.navigation.state.params.notekey)
 }





  componentWillMount = () => {
    // askForPermissioToReceiveNotifications();
};
slideCards = () => {
    try {
        this.setState({ slideCards: !this.state.slideCards });
    } catch (err) {
        console.log("error at slideCards in dashBoard");
    }
};
/**
 * @description:it handles the cards style
 */
handleCardStyle = () => {
    try {
        this.setState({ cardStyles: !this.state.cardStyles });
    } catch (err) {
        console.log("error at handleCardStyle in dashBoard");
    }
}










  createTable = () => {
    let table = []
    // console.log(this.state.fetchEvent, "finally the data");
    // Outer loop to create parent
    if (this.state.fetchEvent) {
      for (let i = 0; i < this.state.fetchEvent.length; i++) {
        let children = []
        //Inner loop to create children
        for (let j = 0; j < 2; j++) {
          children.push(<td>
            <Card className="eventCard">
            <CardContent>

              {/* <Typography className="title" variant="h5" component="h2">
                {this.state.fetchEvent[i].team1Name} Vs {this.state.fetchEvent[i].team1Name}
              </Typography> */}

              {/* 
              <Typography variant="h5" component="h4">
                {this.state.fetchEvent[i].eventDate}
              </Typography> */}


              {/* <Typography className="pos" color="textSecondary">
                {this.state.fetchEvent[i].eventTime}
              </Typography> */}



              <div id={this.state.fetchEvent[i].id} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}   >

                <div style={{ fontSize: 25,  color: 'black' }}>
                  {this.state.fetchEvent[i].team1Name}
                  {/* <p>{this.props.Display.team1Name}</p> */}
                </div>

                <p style={{ fontSize: '25px', margin: 5, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>v/s</p>

                <div style={{ fontSize: 25,  color: 'black' }}>
                  {/* <p>{this.props.Display.team2Name}</p> */}
                  {this.state.fetchEvent[i].team1Name}
                </div>

              </div>






              <div style={{ fontSize: 25, color: 'black', textAlign: 'center' }}>
                {/* <p>{this.props.Display.eventDate}</p> */}
                <p>Today</p>
              </div>

              <div style={{ fontSize: 25, color: 'black', textAlign: 'center' }} >
                {/* <p>{this.props.Display.eventTime}</p> */}
                {this.state.fetchEvent[i].eventTime}

              </div>




            </CardContent>


            <CardActions>
              {/* <Button size="small" className="FloatButtonL"><i className="fa-fa-circle"></i></Button> */}
              {/* <Button className="FloatButtonR" size="small" onClick={this.DeleteMe(this.state.fetchEvent[i])}>Delete</Button> */}


              <div className="cardEditDel">

                <MenuItem
                  id={this.state.fetchEvent[i].id}
                  // onClick={this.props.('/editData')}
                  onClick={(event)=>this.editClick(event)}
                >
                  <img
                    src={require('../assets/edit-24px.svg')}
                    alt='EditIcon'
                    id={this.state.fetchEvent[i].id}
                  />
                </MenuItem>



                <MenuItem
                  id={this.state.fetchEvent[i].id}
                  onClick={this.trash}
                >
                  <img
                    src={require('../assets/delete-24px.svg')}
                    alt='DeleteIcon'
                    id={this.state.fetchEvent[i].id}
                    // event.target.parentElement.id
                  />
                </MenuItem>

              </div>


            </CardActions>
          </Card></td>)
        }
        //Create the parent and add the children
        table.push(<tr>{children}</tr>)
      }
      return table
    }

  }
  DeleteMe = (data) => {
    // console.log(data)

  }
  render() {



    const { classes } = this.props;
    const slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";


    return (

      <div className={classes.root}>
        <div className={slidingCards} id={slidingCards}>

          <div>
            <TopBar
              slideCards={this.slideCards}
              props={this.props}
              notePropsToApp={this.handleCardStyle}
              handleNavigation={this.handleNavigation}
            />
          </div>

        </div>








        <div>
          <table className="tableView">
            <tbody>
              {this.createTable()}
            </tbody>
          </table>
        </div>








      </div>

    );
  }
}


EventsPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(EventsPage);